import type { NavigateFunction, NavigateOptions } from 'react-router-dom'

type NavigationMouseEvent = Pick<MouseEvent, 'metaKey' | 'ctrlKey' | 'button'> & {
    preventDefault: () => void
}

export const isModifiedNavigationClick = (e: NavigationMouseEvent) => e.metaKey || e.ctrlKey || e.button === 1

export const openInNewTab = (path: string) => {
    window.open(path, '_blank', 'noopener,noreferrer')
}

export const navigateOnClick = (
    e: NavigationMouseEvent,
    path: string,
    navigate: NavigateFunction,
    options?: NavigateOptions
) => {
    if (isModifiedNavigationClick(e)) {
        e.preventDefault()
        openInNewTab(path)
        return
    }
    navigate(path, options)
}
